import { MarketplaceSoldsLink } from "@/components/market/MarketplaceSoldsLink";
import type { FanaticsSoldsSearch } from "@/lib/scan/fanaticsSolds";

/** Opens Fanatics sold history for the selected grader or ungraded cards. */
export function FanaticsSoldsLink(props: {
  search: FanaticsSoldsSearch;
  testID: string;
  /** Public pages disable authenticated analytics. */
  track?: boolean;
  /** Web only: compact layout inside the sales table. */
  inline?: boolean;
}) {
  return <MarketplaceSoldsLink {...props} />;
}
